import React from "react";
import { MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useDispatch } from "react-redux";
import { downloadBackup } from "../../core/actions/reportDownloadAction";

const BackupDownloadMenu = () => {
  const dispatch = useDispatch();

  const handleDownloadBackup = () => {
    const data = {}; // pass required payload if any

    dispatch(
      downloadBackup(data, (response) => {
        // SUCCESS OR ERROR CALLBACK
        if (typeof response === "string") {
          console.error("Backup download failed:", response);
        } else {
          console.log("Backup download success", response);
        }
      })
    );
  };

  return (
    <MenuItem onClick={handleDownloadBackup}>
      <ListItemIcon>
        <DownloadIcon color="primary" />
      </ListItemIcon>
      <ListItemText primary="Download Backup" />
    </MenuItem>
  );
};

export default BackupDownloadMenu;
